import React, { useState } from 'react';
import { DatabaseIcon, SearchIcon, FilterIcon } from 'lucide-react';
import { AssetDetailModal } from './AssetDetailModal';
import { AddAssetModal } from '../shared/AddAssetModal';
import { SuccessNotification } from '../shared/SuccessNotification';
export const AssetManagement: React.FC = () => {
  // Sample asset data
  const [allAssets, setAllAssets] = useState([{
    id: 'AST-001',
    name: 'Server Database Utama',
    category: 'Server & Komputasi',
    location: 'Pusat/Setuma',
    status: 'Aktif',
    classification: 'Sangat Rahasia',
    lastUpdate: '2026-01-15'
  }, {
    id: 'AST-002',
    name: 'Lisensi Oracle Enterprise',
    category: 'Software & Lisensi',
    location: 'BINDA Jawa Timur',
    status: 'Akan Habis',
    classification: 'Rahasia',
    lastUpdate: '2026-01-22'
  }, {
    id: 'AST-003',
    name: 'Router Backbone STIN',
    category: 'Jaringan & Komunikasi',
    location: 'STIN',
    status: 'Perlu Perawatan',
    classification: 'Rahasia',
    lastUpdate: '2026-01-30'
  }, {
    id: 'AST-004',
    name: 'Firewall Pusat Data',
    category: 'Keamanan Siber',
    location: 'BINDA Sumatera Barat',
    status: 'Kritis',
    classification: 'Sangat Rahasia',
    lastUpdate: '2026-01-05'
  }, {
    id: 'AST-005',
    name: 'Platform Virtualisasi VMware',
    category: 'Infrastruktur Digital',
    location: 'Deputi II',
    status: 'Aktif',
    classification: 'Rahasia',
    lastUpdate: '2026-01-18'
  }, {
    id: 'AST-006',
    name: 'Switch Core Cisco Nexus',
    category: 'Jaringan & Komunikasi',
    location: 'Pusat/Setuma',
    status: 'Aktif',
    classification: 'Sangat Rahasia',
    lastUpdate: '2026-01-05'
  }, {
    id: 'AST-007',
    name: 'Lisensi Windows Server 2022',
    category: 'Software & Lisensi',
    location: 'STIN',
    status: 'Aktif',
    classification: 'Rahasia',
    lastUpdate: '2026-01-22'
  }, {
    id: 'AST-008',
    name: 'Perangkat Enkripsi Jaringan',
    category: 'Keamanan Siber',
    location: 'BINDA Jawa Timur',
    status: 'Perlu Perawatan',
    classification: 'Sangat Rahasia',
    lastUpdate: '2026-01-12'
  }, {
    id: 'AST-009',
    name: 'Storage Array NAS Enterprise',
    category: 'Server & Komputasi',
    location: 'Deputi I',
    status: 'Aktif',
    classification: 'Terbuka',
    lastUpdate: '2026-01-01'
  }, {
    id: 'AST-010',
    name: 'Sistem Backup & Recovery',
    category: 'Infrastruktur Digital',
    location: 'Pusat/Setuma',
    status: 'Aktif',
    classification: 'Rahasia',
    lastUpdate: '2026-01-15'
  }]);
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [notification, setNotification] = useState({
    show: false,
    message: ''
  });
  // State for filters
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  // Filter assets based on search and filters
  const filteredAssets = allAssets.filter(asset => {
    const matchesSearch = asset.name.toLowerCase().includes(searchTerm.toLowerCase()) || asset.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = categoryFilter === '' || asset.category === categoryFilter;
    const matchesStatus = statusFilter === '' || asset.status === statusFilter;
    return matchesSearch && matchesCategory && matchesStatus;
  });
  // Pagination
  const totalPages = Math.ceil(filteredAssets.length / itemsPerPage);
  const paginatedAssets = filteredAssets.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  // Function to open asset detail modal
  const handleViewAssetDetail = asset => {
    setSelectedAsset(asset);
    setIsModalOpen(true);
  };
  // Function to export data
  const handleExportData = () => {
    setNotification({
      show: true,
      message: 'Data aset berhasil diekspor ke Excel'
    });
  };
  // Function to add new asset
  const handleAddAsset = () => {
    setIsAddModalOpen(true);
  };
  const handleSubmitAsset = (newAsset: any) => {
    setAllAssets([newAsset, ...allAssets]);
    setIsAddModalOpen(false);
    setNotification({
      show: true,
      message: `Aset ${newAsset.name} berhasil ditambahkan`
    });
  };
  return <div className="space-y-4" data-id="element-1576">
      <div className="flex items-center justify-between mb-4" data-id="element-1577">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-1578">
          <DatabaseIcon size={24} className="mr-2" data-id="element-1579" />
          Manajemen Aset
        </h1>
        <div className="flex space-x-2" data-id="element-1580">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" onClick={handleExportData} data-id="element-1581">
            Ekspor Data
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" onClick={handleAddAsset} data-id="element-1582">
            + Tambah Aset
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1583">
        <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-1584">
          <div className="relative flex-grow max-w-md" data-id="element-1585">
            <input type="text" placeholder="Cari aset..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-1586" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1587" />
          </div>
          <div className="flex items-center gap-2" data-id="element-1588">
            <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-1589">
              <FilterIcon size={16} className="mr-1" data-id="element-1590" />
              Filter
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} data-id="element-1591">
              <option value="" data-id="element-1592">Kategori</option>
              <option value="Server & Komputasi" data-id="element-1593">Server & Komputasi</option>
              <option value="Jaringan & Komunikasi" data-id="element-1594">
                Jaringan & Komunikasi
              </option>
              <option value="Software & Lisensi" data-id="element-1595">Software & Lisensi</option>
              <option value="Keamanan Siber" data-id="element-1596">Keamanan Siber</option>
              <option value="Infrastruktur Digital" data-id="element-1597">
                Infrastruktur Digital
              </option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-1598">
              <option value="" data-id="element-1599">Status</option>
              <option value="Aktif" data-id="element-1600">Aktif</option>
              <option value="Perlu Perawatan" data-id="element-1601">Perlu Perawatan</option>
              <option value="Akan Habis" data-id="element-1602">Akan Habis</option>
              <option value="Kritis" data-id="element-1603">Kritis</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1604">
          <table className="w-full" data-id="element-1605">
            <thead className="bg-neutral-light" data-id="element-1606">
              <tr data-id="element-1607">
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1608">
                  ID Aset
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1609">
                  Nama Aset
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1610">
                  Kategori
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1611">
                  Lokasi
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1612">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1613">
                  Klasifikasi
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1614">
                  Terakhir Diperbarui
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-1615">
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1616">
              {paginatedAssets.map(asset => <tr key={asset.id} className="hover:bg-neutral-light" data-id="element-1617">
                  <td className="px-4 py-3 text-sm text-gray-900" data-id="element-1618">
                    {asset.id}
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-1619">
                    {asset.name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1620">
                    {asset.category}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1621">
                    {asset.location}
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-1622">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${asset.status === 'Aktif' ? 'bg-green-100 text-green-800' : asset.status === 'Perlu Perawatan' ? 'bg-yellow-100 text-yellow-800' : asset.status === 'Akan Habis' ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`} data-id="element-1623">
                      {asset.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-1624">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${asset.classification === 'Sangat Rahasia' ? 'bg-red-100 text-red-800' : asset.classification === 'Rahasia' ? 'bg-orange-100 text-orange-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-1625">
                      {asset.classification}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-700" data-id="element-1626">
                    {asset.lastUpdate}
                  </td>
                  <td className="px-4 py-3 text-sm" data-id="element-1627">
                    <button className="text-accent-info hover:underline" onClick={() => handleViewAssetDetail(asset)} data-id="element-1628">
                      Detail
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 border-t border-gray-200 flex items-center justify-between" data-id="element-1629">
          <div className="text-sm text-gray-700" data-id="element-1630">
            Menampilkan {(currentPage - 1) * itemsPerPage + 1}-
            {Math.min(currentPage * itemsPerPage, filteredAssets.length)} dari{' '}
            {filteredAssets.length} aset
          </div>
          <div className="flex items-center space-x-2" data-id="element-1631">
            <button className={`px-3 py-1 border border-gray-300 rounded-md text-sm ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} data-id="element-1632">
              Sebelumnya
            </button>
            {/* Page numbers */}
            {Array.from({
            length: Math.min(3, totalPages)
          }, (_, i) => {
            // Show current page and adjacent pages
            const pageNum = currentPage + i - 1;
            if (pageNum < 1 || pageNum > totalPages) return null;
            return <button key={pageNum} className={`px-3 py-1 ${pageNum === currentPage ? 'bg-secondary text-white' : 'border border-gray-300 hover:bg-gray-100'} rounded-md text-sm`} onClick={() => setCurrentPage(pageNum)} data-id="element-1633">
                    {pageNum}
                  </button>;
          })}
            {totalPages > 3 && currentPage < totalPages - 1 && <span className="text-gray-500" data-id="element-1634">...</span>}
            {totalPages > 3 && currentPage < totalPages - 1 && <button className="px-3 py-1 border border-gray-300 rounded-md text-sm hover:bg-gray-100" onClick={() => setCurrentPage(totalPages)} data-id="element-1635">
                {totalPages}
              </button>}
            <button className={`px-3 py-1 border border-gray-300 rounded-md text-sm ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'}`} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} data-id="element-1636">
              Berikutnya
            </button>
          </div>
        </div>
      </div>
      {/* Asset Detail Modal */}
      <AssetDetailModal asset={selectedAsset} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-1637" />

      {/* Add Asset Modal */}
      <AddAssetModal isOpen={isAddModalOpen} onClose={() => setIsAddModalOpen(false)} onSubmit={handleSubmitAsset} data-id="element-1638" />

      {/* Success Notification */}
      <SuccessNotification message={notification.message} isVisible={notification.show} onClose={() => setNotification({
      ...notification,
      show: false
    })} data-id="element-1639" />
    </div>;
};